var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app-bar',{attrs:{"color":"cyan","dark":"","app":""}},[_c('v-app-bar-nav-icon',{on:{"click":_vm.send}}),_c('v-toolbar-title',[_vm._v("CL Procesos S.A.")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }